export default __webpack_public_path__ + "static/media/9-Milky Way.795fc277.svg";